import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './services/auth-guard.service';
import { TermsComponent } from './pages/singlepage/terms/terms.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/apikeys',
    pathMatch: 'full', // 必須: 完全一致する場合にのみリダイレクト
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [


      {
        path: 'apikeys',
        loadChildren: () =>
          import('./pages/apikey/apikey.module').then(
            (m) => m.ApikeyModule
          ),
      },

      {
        path: 'account',
        loadChildren: () =>
          import('./pages/account/account.module').then(
            (m) => m.AccountModule
          ),
      },

      {
        path: 'billing',
        loadChildren: () =>
          import('./pages/billing/billing.module').then(
            (m) => m.BillingModule
          ),
      },

      {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.module').then(
            (m) => m.AdminModule
          ),
      },

    ],
  },
  {
    path: 'auth',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/singlepage/singlepage.module').then(
            (m) => m.SinglePageModule
          ),
      },
    ],
  },
  { path: '**', redirectTo: '/apikeys' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: "top"
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
